import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import api, { formatApiError } from "../lib/api";

export default function RedefinirSenha() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password !== form.confirm) {
      setError("As senhas não coincidem.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: form.password });
      navigate("/entrar", { state: { reset: true } });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050505] px-6" data-testid="redefinir-senha-page">
      <div className="grain-overlay" aria-hidden="true" />
      <div className="pointer-events-none fixed inset-0 bg-[radial-gradient(ellipse_at_50%_20%,rgba(212,175,55,0.08),transparent_55%)]" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative w-full max-w-md border border-gold/20 bg-[#0a0a0a]/90 p-10 backdrop-blur-xl"
      >
        <h1 className="font-serif text-3xl text-zinc-100">Nova senha</h1>
        {!token ? (
          <div data-testid="reset-missing-token">
            <p className="mt-6 text-sm leading-relaxed text-zinc-400">Link inválido. Solicite uma nova redefinição.</p>
            <Link to="/recuperar-senha" className="btn-gold mt-8 w-full" data-testid="reset-request-new-link">Solicitar novo link</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 flex flex-col gap-5" data-testid="reset-form">
            <input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="input-dark" placeholder="Nova senha (mín. 6 caracteres)" data-testid="reset-password-input" />
            <input type="password" required minLength={6} value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className="input-dark" placeholder="Confirme a nova senha" data-testid="reset-confirm-input" />
            {error && <p className="border border-red-900/50 bg-red-950/30 px-4 py-3 text-sm text-red-300" data-testid="reset-error-message">{error}</p>}
            <button type="submit" disabled={loading} className="btn-gold w-full" data-testid="reset-submit-button">
              {loading ? "Salvando…" : "Salvar nova senha"}
            </button>
          </form>
        )}
      </motion.div>
    </div>
  );
}
